export default [
  {
    path: '/login',
    name: 'Login',
    component: require('@/pages/InAppWeb/Login').default,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: require('@/pages/InAppWeb/Logout').default,
  },
]
